
<ng-container *ngIf="{
  row: columnData | async,
  adata: additionData | async
} as $">
<span *ngIf="$.row && $.adata.fetch_key" [pTooltip]="showDate($.row[$.adata.fetch_key])" >{{ $.row[$.adata.fetch_key]  | DayAgo : hasValue($.adata.applytimezone) ? $.adata.applytimezone: true }} </span>
</ng-container>
